// Texty expedície — slovenské dvojča locale/cs/dispatchEta.js.
export default {
  prefix: 'Expedujeme ',
  today: 'dnes',
  tomorrow: 'zajtra',
  days: ['v nedeľu', 'v pondelok', 'v utorok', 'v stredu', 'vo štvrtok', 'v piatok', 'v sobotu'],
};
